export default __webpack_public_path__ + "static/media/resume.f604438e.svg";